import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import windowReducer from "./windowSlice";
import conversationIdSlice from "./conversationIdSlice";
import modelsSlice from "./modelsSlice";
import modelSlice from "./modelSlice";
import messagesSlice from "./messagesSlice";
import conversationStartIndexSlice from "./conversationStartIndexSlice";
import conversationsSlice from "./conversationsSlice";
import imagesSlice from "./imagesSlice";
import modelPanelSlice from "./modelPanelSlice";
import sideBarSlice from "./sideBarSlice";
import templatesSlice from "./templatesSlice";
import promptSlice from "./promptSlice";
import messagesStatusSlice from "./messagesStatusSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    window: windowReducer,
    conversationId: conversationIdSlice,
    models: modelsSlice,
    model: modelSlice,
    messages: messagesSlice,
    conversationStartIndex: conversationStartIndexSlice,
    conversations: conversationsSlice,
    images: imagesSlice,
    modelPanel: modelPanelSlice,
    sideBar: sideBarSlice,
    templates: templatesSlice,
    prompt: promptSlice,
    messagesStatus: messagesStatusSlice,
  },
});
